{
  "version": 1,
  "asset_id": "4f56a3f9-7f8d-42ad-b590-62e8bd576a9c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4f56a3f9-7f8d-42ad-b590-62e8bd576a9c/sleeve-endoscopy-check-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4f56a3f9-7f8d-42ad-b590-62e8bd576a9c/sleeve-endoscopy-check-es-800.webp",
  "original_filename": "sleeve-endoscopy-check-es-800.webp",
  "size": 42242,
  "content_type": "image/webp",
  "created_at": "2026-10-05T00:21:52Z"
}
